// import React, { useEffect } from "react";
// import "./MegaMenu.css";
// import { Link } from "react-router-dom";

// const MegaMenu = ({ type, menuData, onProductClick }) => {
//   // Get data for this menu type from props
//   const data = menuData[type] || { categories: [], products: [] };
//   // Add this to HeaderUp.jsx
//   useEffect(() => {
//     const updateMegaMenuPosition = () => {
//       const header = document.querySelector(".header");
//       if (header) {
//         const headerHeight = header.offsetHeight;
//         const megaMenus = document.querySelectorAll(".mega-menu");
//         megaMenus.forEach((menu) => {
//           menu.style.top = `${headerHeight}px`;
//         });
//       }
//     };

//     updateMegaMenuPosition();
//     window.addEventListener("resize", updateMegaMenuPosition);

//     return () => window.removeEventListener("resize", updateMegaMenuPosition);
//   }, []);
//   return (
//     <div className="mega-menu">
//       <div className="mega-menu-content">
//         <div className="mega-menu-left">
//           {data.categories && data.categories.length > 0 ? (
//             data.categories.map((category, index) => (
//               <div key={category.id || index} className="category-section">
//                 <h3>{category.title}</h3>
//                 <ul>
//                   {category.items.map((item, idx) => (
//                     <li key={item.id || idx}>
//                       <Link to={`/products/${item.slug || item.name}`}>
//                         {item.name || item}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))
//           ) : (
//             <div className="category-section">
//               <p>No categories available</p>
//             </div>
//           )}
//         </div>

//         <div className="mega-menu-right">
//           <h3 className="featured-title">Featured Products</h3>
//           {/* <div className="featured-products">
//             {data.products && data.products.length > 0 ? (
//               data.products.slice(0, 4).map((product, index) => (
//                 <div key={product.id || index} className="product-card-mini">
//                   {console.log(product, "product in header")}
//                   <div className="product-image">
//                     <img
//                       src={product.image[0]?.url || ""}
//                       alt={product.name}
//                       onError={(e) => {
//                         e.target.src =
//                           "https://via.placeholder.com/300x400?text=No+Image";
//                       }}
//                     />
//                   </div>
//                   <div className="product-info">
//                     <p className="product-name">{product.name}</p>
//                     <span className="price">₹ {product.price}</span>
//                     <Link
//                       // to={`/product/${product.slug}`}
//                       // className="btn-quick-view"
//                       onClick={() =>
//                         onProductClick({ ...product, images: product.image })
//                       }
//                     >
//                       Quick View
//                     </Link>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p
//                 style={{ padding: "20px", textAlign: "center", color: "#999" }}
//               >
//                 No featured products available
//               </p>
//             )}
//           </div> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MegaMenu;

import React, { useEffect } from "react";
import "./MegaMenu.css";
import { Link } from "react-router-dom";

const MegaMenu = ({ type, menuData, id, onProductClick }) => {
  console.log(menuData, id, "id in mega menue");
  // Get data for this menu type from props
  const data = menuData[type] || { categories: [], products: [] };

  useEffect(() => {
    const updateMegaMenuPosition = () => {
      const header = document.querySelector(".header");
      if (header) {
        const headerHeight = header.offsetHeight;
        const megaMenus = document.querySelectorAll(".mega-menu");
        megaMenus.forEach((menu) => {
          menu.style.top = `${headerHeight}px`;
        });
      }
    };

    updateMegaMenuPosition();
    window.addEventListener("resize", updateMegaMenuPosition);

    return () => window.removeEventListener("resize", updateMegaMenuPosition);
  }, []);

  return (
    <div className="mega-menu">
      <div className="mega-menu-content">
        <div className="mega-menu-left">
          {data.categories && data.categories.length > 0 ? (
            data.categories.map((category, index) => (
              <div key={category.id || index} className="category-section">
                <h3>{category.title}</h3>
                <ul>
                  {category.items.map((item, idx) => (
                    <li key={item.id || idx}>
                      <Link
                        to={`/products/${item.name || item.slug}`}
                        state={{ product: item, cata: category, data: data }}
                      >
                        {item.name || item}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))
          ) : (
            <div className="category-section">
              <p>No categories available</p>
            </div>
          )}
        </div>

        <div className="mega-menu-right">
          <h3 className="featured-title">Featured Products</h3>
          {/* <div className="featured-products">
            {data.products && data.products.length > 0 ? (
              data.products.slice(0, 2).map((product, index) => (
                <div key={product.id || index} className="product-card-mini">
                  <div className="product-image">
                    <img
                      src={product.image[0]?.url || ""}
                      alt={product.name}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/300x400?text=No+Image";
                      }}
                    />
                  </div>
                  <div className="product-info">
                    <p className="product-name">{product.name}</p>
                    <span className="price">₹ {product.price}</span>
                    <button
                      className="btn-quick-view"
                      onClick={() =>
                        onProductClick({ ...product, images: product.image })
                      }
                    >
                      Quick View
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p
                style={{ padding: "20px", textAlign: "center", color: "#999" }}
              >
                No featured products available
              </p>
            )}
          </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "600px",
            }}
          >
            {data.products && data.products.length > 0
              ? data.products.slice(0, 2).map((product, index) => (
                  <img
                    onClick={() =>
                      onProductClick({ ...product, images: product.image })
                    }
                    src={product.image[0]?.url || ""}
                    style={{
                      height: "320px",
                      width: "300px",
                      objectFit: "contain",
                      marginRight: "10px",
                      // marginLeft: "-10px",
                    }}
                  />
                ))
              : ""}
            {/* <img
              src="/images/testim.jpeg"
              style={{
                height: "350px",
                width: "310px",
                objectFit: "contain",
                marginRight: "10px",
                marginLeft: "-10px",
              }}
            />
            <img
              src="/images/testim.jpeg"
              style={{
                height: "350px",
                width: "310px",
                objectFit: "contain",
                marginRight: "10px",
              }}
            /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
